import analytics from '@utils/analytics';
import Swiper, { A11y, Navigation } from 'swiper';
import BaseComponent from '../base/baseComponent';
Swiper.use([Navigation, A11y]);
export default class TextSquaresCarouselComponent extends BaseComponent {
    constructor(element) {
        super(element);
        console.log('squaresText');
        this.initSlider();
        window.dispatchEvent(new Event('aos:refresh'));
    }
    initSlider() {
        const swiper = new Swiper(this.$el, {
            spaceBetween: 4,
            freeMode: true,
            slidesPerView: 1,
            navigation: {
                nextEl: this.$el.querySelector('.swiper-button-next'),
                prevEl: this.$el.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                600: {
                    freeMode: false,
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: parseInt(this.$options.slideslength) > 3 ? 4 : 3,
                    spaceBetween: 0,
                },
            },
            a11y: {
                enabled: true,
                prevSlideMessage: this.$options.prevslidemessage,
                nextSlideMessage: this.$options.nextslidemessage,
                firstSlideMessage: this.$options.firstslidemessage,
                lastSlideMessage: this.$options.lastslidemessage,
            },
        });
        swiper.on('slideChange', function () {
            analytics.dragToExplore();
        });
    }
}
